import lodash from "lodash";
import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../../utils/form";
import { callRequestStatus, callRequestType } from "../../../storage-location/request/request.section";
import {
    createFieldSelect,
    createFieldTextArea
} from "../../../../../components/input/template-builder/template-builder.logic";
import { Modal } from "ant-design-vue";
import router from "../../../../../router";
import { createSearchOneCriteria } from "../request/request.logic";
import moment from "moment";

export const callUserObjective = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery }).then(items => items.filter(item => ["1", "2"].includes(item.key)));
export const callDepartment = ({ searchQuery }) => store.dispatch("resource/v1/master/department/cacheFindAll", { searchQuery });
export const callRequestDoc = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_DOC", value: searchQuery });

export const callSequestrateInform = ({ searchQuery, userInfo }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id },
    ];
    if (searchQuery) {
        where.push({ name: "refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/sequestrate/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refUserCompany.id", "refUserCompany.fullNameTh",
                    "refReleaseProduct.id",
                    "refReleaseProduct.refRelease.id",
                    "refReleaseProduct.refRelease.approveCode",
                    "refReleaseProduct.refRelease.refInspection.id",
                    "refReleaseProduct.refRelease.refInspection.approveCode",
                    "refReleaseProduct.refRelease.refInspection.refInformTemp.id",
                    "refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode",
                ],
                page: 0,
                size: 1000000,
                where,
                sort: [
                    { name: "refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode", type: "DESC" },
                    { name: "approveCode", type: "DESC" }
                ]
            }
        })
        .then(page => lodash.uniqBy(page.data, "refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode"));
};

export const callSequestrate = ({ searchQuery, model, userInfo }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id },
    ];
    const informApproveCode = model.refSequestrate?.refReleaseProduct?.refRelease?.refInspection?.refInformTemp?.approveCode;
    if (informApproveCode) {
        where.push({ name: "refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode", type: "String", operator: "=", value: informApproveCode });
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/sequestrate/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode",
                    "refReleaseProduct.id",
                    "refReleaseProduct.refRelease.id",
                    "refReleaseProduct.refRelease.approveCode",
                    "refReleaseProduct.refRelease.refInspection.id",
                    "refReleaseProduct.refRelease.refInspection.approveCode",
                    "refReleaseProduct.refRelease.refInspection.refInformTemp.id",
                    "refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode",
                ],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const callSequestrateFull = ({ props, id }) => {
    const prefix = "refSequestrate.";
    const criteria = {
        ...createSearchOneCriteria({ props, id, prefix }),
        where: [{ name: "refSequestrate.id", type: "UUID", operator: "=", value: id }],
    };
    return store.dispatch("resource/v1/transaction/request/search", { criteria, })
        .then(page => page.data[0])
};

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.sequestrate.refUserCompany"),
            dataIndex: "refSequestrateTemp.refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refSequestrateTemp?.refUserCompany?.refPersonType?.key === "1"
                    ? record.refSequestrateTemp?.refUserCompany?.companyNameTh
                    : record.refSequestrateTemp?.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.request.requestCode"), dataIndex: "requestCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("model.sequestrate.invoiceCode"),
            dataIndex: "refSequestrateTemp.refReleaseProduct.refRelease.products.refInspectionProduct.refInformProduct.invoiceCode",
            align: "center",
            customRender: ({ record }) => {
                const informProduct = record.refSequestrateTemp?.refReleaseProduct?.refInspectionProduct?.refInformProduct || {};
                return <>
                    <div>{informProduct?.invoiceCode}</div>
                    <div>{moment(informProduct?.invoiceDate)?.format("DD/MM/YYYY")}</div>
                </>
            }
        }),
        createColumnDate({
            title: () => i18n.global.t("model.sequestrate.sequestrateDatetime"),
            dataIndex: "refSequestrateTemp.sequestrateDatetime",
            align: "center",
            format: "DD/MM/YYYY HH:mm"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.sequestrate.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.sequestrate.refRequestDoc"),
            dataIndex: "refSequestrateTemp.refReleaseProduct.refRelease.refInspection.refRequestDoc.value",
            inputProp: () => ({
                list: ({searchQuery}) => callRequestDoc({ searchQuery }).then(d => d.filter(doc=>["02", "16", "17", "18", "19"].includes(doc?.key))),
                optLabel: "value"
            }),
            search: { name: "refSequestrateTemp.refReleaseProduct.refRelease.refInspection.refRequestDoc.id" },
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.sequestrateInfo.referDoc"),
            dataIndex: "refSequestrateTemp.refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({
                list: ({searchQuery}) => callRequestStatus({ searchQuery }),
                optLabel: "value"
            }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const fields = [
        ...createFieldRequest({ props, data, key }),
    ];
    return fields;
};

export const createFieldRequest = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                model.refRequestType = value;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callRequestType({ searchQuery }).then(d=>d.filter(d2 => ["2"].includes(d2?.key))),
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSequestrate.refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.sequestrateInfo.referDoc"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refSequestrate,
                            "onUpdate:value": value => {
                                const oldValue = model.refSequestrate;
                                model.refSequestrate = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.storageLocation.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => {
                                            cloneSequestrate({ props, model, id: value?.id })
                                        },
                                        onCancel: () => {
                                            model.refSequestrate = oldValue;
                                        }
                                    });
                                } else {
                                    cloneSequestrate({ props, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callSequestrateInform({ searchQuery, userInfo: lodash.cloneDeep(store.state.resource.auth.info?.user) }),
                            optLabel: "refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSequestrate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.sequestrate.approveCode"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refSequestrate,
                            "onUpdate:value": value => {
                                const oldValue = model.refSequestrate;
                                model.refSequestrate = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.storageLocation.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneSequestrate({ props, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refSequestrate = oldValue;
                                        }
                                    });
                                } else {
                                    cloneSequestrate({ props, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callSequestrate({ searchQuery, model, userInfo: lodash.cloneDeep(store.state.resource.auth.info?.user) }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.approveCode} - {item.refUserCompany?.fullNameTh}
                                </div>
                            ),
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.sequestrateInfo.remark"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.remark,
                            "onUpdate:value": value => {model.remark = value},
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.sequestrateInfo.descToApprove"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => {model.lastStatus.forRequestRemark[0].remark = value},
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forApproveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.sequestrateInfo.descToRequest"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forApproveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forApproveRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
};

export const cloneSequestrate = ({ props, model, id }) => {
    if (id) {
        callSequestrateFull({ props, id }).then(request => {
            const sequestrate = request.refSequestrate;
            const refSequestrateTemp = copyForm({ form: { ...sequestrate, approveCode: null, isTemp: true } });
            if (id) {
                refSequestrateTemp?.attachments?.forEach((d, index) => (d.refRealId = sequestrate.attachments[index].id));
                refSequestrateTemp?.distributors?.forEach((d, index) => {
                    d.refReal = { id: sequestrate.distributors[index].id }
                    d.refSequestrate = null;
                });
            }
            router.push({
                name: router.currentRoute.value.name,
                params: { props: JSON.stringify({ form: { ...model, refDepartment: sequestrate?.refDepartment, refUserCompany: sequestrate?.refUserCompany, refSequestrateTemp } }) },
                query: { _timestamp: new Date().getTime() }
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};